// Auto-generated file. Do not edit manually.
// Generated on: 2026-02-12T10:07:31.707Z

export const platformTranslations = {
  "platform.blueprint-version.breakingchangesdialog.breaking_changes_detected": {
    "en": "Breaking Changes Detected",
    "ar": "تم الكشف عن تغييرات جذرية",
    "nl": "",
    "fr": "",
    "de": ""
  },
  "platform.blueprint-version.breakingchangesdialog.field_changed_and_has_value": {
    "en": "Field changed and has value",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.blueprint-version.breakingchangesdialog.issues": {
    "en": "Issues:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.blueprint-version.breakingchangesdialog.no_items_with_breaking_changes_found": {
    "en": "No items with breaking changes found",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.blueprint-version.breakingchangesdialog.note": {
    "en": "Note:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.blueprint-version.breakingchangesdialog.required_field_is_missing": {
    "en": "Required field is missing",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.blueprint-version.bulkupdatedialog.bulk_update_glossary_items": {
    "en": "Bulk Update Glossary Items",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.blueprint-version.bulkupdatedialog.changes": {
    "en": "Changes:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.blueprint-version.bulkupdatedialog.failed": {
    "en": "Failed",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.blueprint-version.bulkupdatedialog.no_items_need_to_be_updated": {
    "en": "No items need to be updated",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.blueprint-version.bulkupdatedialog.skipped": {
    "en": "Skipped",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.blueprint-version.bulkupdatedialog.successful": {
    "en": "Successful",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.blueprint-version.bulkupdatedialog.update_strategy": {
    "en": "Update Strategy:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.blueprint-version.migrationpreviewdialog.added": {
    "en": "Added",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.blueprint-version.migrationpreviewdialog.merge_recommended": {
    "en": "Merge (Recommended)",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.blueprint-version.migrationpreviewdialog.migration_strategy": {
    "en": "Migration Strategy",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.blueprint-version.migrationpreviewdialog.modified": {
    "en": "Modified",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.blueprint-version.migrationpreviewdialog.overwrite": {
    "en": "Overwrite",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.blueprint-version.migrationpreviewdialog.preview_blueprint_upgrade": {
    "en": "Preview Blueprint Upgrade",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.blueprint-version.migrationpreviewdialog.removed": {
    "en": "Removed",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.blueprint-version.versioncontrolwidget.bump": {
    "en": "Bump:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.blueprint-version.versioncontrolwidget.current": {
    "en": "Current:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.blueprint-version.versioncontrolwidget.major": {
    "en": "Major",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.blueprint-version.versioncontrolwidget.minor": {
    "en": "Minor",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.blueprint-version.versioncontrolwidget.next": {
    "en": "Next:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.blueprint-version.versioncontrolwidget.patch": {
    "en": "Patch",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.blueprint-version.versionhistorypanel.no_version_history_available": {
    "en": "No version history available",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.blueprints.add_objective": {
    "en": "Add objective...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.blueprints.add_tag": {
    "en": "Add tag...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.blueprints.enter_narrative_text": {
    "en": "Enter narrative text...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.blueprints.enter_narrative_title": {
    "en": "Enter narrative title...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.blueprints.enter_title": {
    "en": "Enter title...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.blueprints.narrative_text": {
    "en": "Narrative Text",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.blueprints.narrative_title": {
    "en": "Narrative Title",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.blueprints.no_objectives": {
    "en": "No objectives",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.blueprints.objectives": {
    "en": "Objectives",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.blueprints.remove_objective": {
    "en": "Remove objective",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.blueprints.tutorial_step": {
    "en": "Tutorial Step",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.text-fields.bullet_list": {
    "en": "Bullet List",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.text-fields.highlight_as": {
    "en": "Highlight as:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.text-fields.highlight_text": {
    "en": "Highlight Text",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.text-fields.jill": {
    "en": "Jill",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.text-fields.no_highlight_items_available": {
    "en": "No highlight items available",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.text-fields.numbered_list": {
    "en": "Numbered List",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.6366f1": {
    "en": "#6366f1",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.add_filter": {
    "en": "Add Filter",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.blueprint_version": {
    "en": "Blueprint Version:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.brief_description_of_what_this_type_represents": {
    "en": "Brief description of what this type represents",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.cancel_esc": {
    "en": "Cancel (Esc)",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.click_to_add_element": {
    "en": "Click to add element",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.click_to_add_translation": {
    "en": "Click to add translation",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.click_to_add_translation_title": {
    "en": "Click to add translation",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.click_to_add_translation_title_2": {
    "en": "Click to add translation",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.click_to_edit": {
    "en": "Click to edit",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.click_to_edit_title": {
    "en": "Click to edit",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.column_visibility": {
    "en": "Column Visibility",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.column_visibility_2": {
    "en": "Column Visibility",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.comments": {
    "en": "Comments",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.create_new_type": {
    "en": "Create New Type",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.create_tag_group": {
    "en": "Create Tag Group",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.create_type": {
    "en": "Create Type",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.create_your_first_tag_group_to_get_started": {
    "en": "Create your first tag group to get started",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.delete_element": {
    "en": "Delete element",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.delete_tag": {
    "en": "Delete tag",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.delete_type": {
    "en": "Delete type",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.edit_element": {
    "en": "Edit element",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.edit_tag": {
    "en": "Edit tag",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.edit_type": {
    "en": "Edit type",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.eg_character_weapon_location": {
    "en": "e.g., Character, Weapon, Location",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.eg_weapons_characters_attributes": {
    "en": "e.g., weapons, characters, attributes",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.eg_weapons_characters_ui_elements": {
    "en": "e.g., Weapons, Characters, UI Elements",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.eg_weight_color_size": {
    "en": "e.g., Weight, Color, Size",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.element_description": {
    "en": "Element description",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.element_name": {
    "en": "Element name",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.element_name_placeholder": {
    "en": "Element name",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.elements": {
    "en": "Elements:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.enter_text": {
    "en": "Enter text...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.enter_translation": {
    "en": "Enter translation...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.group": {
    "en": "Group",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.group_placeholder": {
    "en": "Group",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.image_uploaded": {
    "en": "Image uploaded",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.item_data": {
    "en": "Item Data",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.item_data_2": {
    "en": "Item Data",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.item_version": {
    "en": "Item Version:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.loading_glossary_item": {
    "en": "Loading glossary item...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.loading_strings_data": {
    "en": "Loading strings data...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.loading_tags": {
    "en": "Loading tags...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.loading_types": {
    "en": "Loading types...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.name_health_damage_armor": {
    "en": "name, health, damage, armor",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.no_elements_yet": {
    "en": "No elements yet",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.no_items_selected": {
    "en": "No items selected",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.no_tags_created_yet": {
    "en": "No tags created yet",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.no_tags_selected": {
    "en": "No tags selected",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.not_set": {
    "en": "Not set",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.no_types_created_yet": {
    "en": "No types created yet",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.no_types_selected": {
    "en": "No types selected",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.object_not_found": {
    "en": "Object not found",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.optional_description": {
    "en": "Optional description",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.optional_description_for_this_type": {
    "en": "Optional description for this type",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.please_select_a_game_to_manage_tags": {
    "en": "Please select a game to manage tags",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.please_select_a_game_to_manage_types": {
    "en": "Please select a game to manage types",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.remove_translations": {
    "en": "Remove translations:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.required": {
    "en": "Required",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.save_ctrlenter": {
    "en": "Save (Ctrl+Enter)",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.search": {
    "en": "Search ...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.search_across_all_columns": {
    "en": "Search across all columns...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.sword_shield_armor_helmet": {
    "en": "sword, shield, armor, helmet",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.sword_shield_armor_helmet_placeholder": {
    "en": "sword, shield, armor, helmet",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.tag_name": {
    "en": "Tag name",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.tags": {
    "en": "Tags",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.tip": {
    "en": "Tip:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.type_name": {
    "en": "Type name",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.unapprove_translations": {
    "en": "Unapprove translations:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.uploaded": {
    "en": "Uploaded",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.version_information": {
    "en": "Version Information",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.cards.widgets.view": {
    "en": "View",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.common.actions": {
    "en": "Actions",
    "ar": "الإجراءات",
    "nl": "",
    "fr": "",
    "de": ""
  },
  "platform.common.add_a_tag": {
    "en": "Add a Tag",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.common.cancel": {
    "en": "Cancel",
    "ar": "إلغاء",
    "nl": "",
    "fr": "",
    "de": ""
  },
  "platform.common.c++_code": {
    "en": "C++ Code",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.common.close": {
    "en": "Close",
    "ar": "إغلاق",
    "nl": "",
    "fr": "",
    "de": ""
  },
  "platform.common.create_folder": {
    "en": "Create Folder",
    "ar": "إنشاء مجلد",
    "nl": "",
    "fr": "",
    "de": ""
  },
  "platform.common.create_new_folder": {
    "en": "Create New Folder",
    "ar": "إنشاء مجلد جديد",
    "nl": "",
    "fr": "",
    "de": ""
  },
  "platform.common.creating": {
    "en": "Creating",
    "ar": "إنشاء",
    "nl": "",
    "fr": "",
    "de": ""
  },
  "platform.common.delete": {
    "en": "Delete",
    "ar": "حذف",
    "nl": "",
    "fr": "",
    "de": ""
  },
  "platform.common.description": {
    "en": "Description",
    "ar": "الوصف",
    "nl": "",
    "fr": "",
    "de": ""
  },
  "platform.common.Documentation_view": {
    "en": "Documentation View",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.common.download": {
    "en": "Download",
    "ar": "تنزيل",
    "nl": "",
    "fr": "",
    "de": ""
  },
  "platform.common.duplicate": {
    "en": "Duplicate",
    "ar": "مكرر",
    "nl": "",
    "fr": "",
    "de": ""
  },
  "platform.common.edit": {
    "en": "Edit",
    "ar": "تحرير",
    "nl": "",
    "fr": "",
    "de": ""
  },
  "platform.common.email": {
    "en": "Email",
    "ar": "البريد الإلكتروني",
    "nl": "",
    "fr": "",
    "de": ""
  },
  "platform.common.enter_object_description": {
    "en": "Add a description",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.common.error": {
    "en": "Error",
    "ar": "خطأ",
    "nl": "",
    "fr": "",
    "de": ""
  },
  "platform.common.exportData": {
    "en": "Export Data",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.common.godot_code": {
    "en": "Godot Code",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.common.import": {
    "en": "Import",
    "ar": "استيراد",
    "nl": "",
    "fr": "",
    "de": ""
  },
  "platform.common.json_structure": {
    "en": "Json Structure",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.common.label": {
    "en": "Label",
    "ar": "الملصق",
    "nl": "",
    "fr": "",
    "de": ""
  },
  "platform.common.noChangesDetected": {
    "en": "No changes detected",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.common.normal_view": {
    "en": "Normal View",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.common.open_in_tab": {
    "en": "Open in new Tab",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.common.password": {
    "en": "Password",
    "ar": "كلمة المرور",
    "nl": "",
    "fr": "",
    "de": ""
  },
  "platform.common.preview": {
    "en": "Preview",
    "ar": "معاينة",
    "nl": "",
    "fr": "",
    "de": ""
  },
  "platform.common.refresh": {
    "en": "Refresh",
    "ar": "تحديث",
    "nl": "",
    "fr": "",
    "de": ""
  },
  "platform.common.revert": {
    "en": "Revert",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.common.roblox_code": {
    "en": "Roblox Code",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.common.save": {
    "en": "Save",
    "ar": "حفظ",
    "nl": "",
    "fr": "",
    "de": ""
  },
  "platform.common.SaveChanges": {
    "ar": "حفظ التغييرات",
    "en": "Save Changes",
    "nl": "",
    "fr": "",
    "de": ""
  },
  "platform.common.saving": {
    "en": "Saving...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.common.settings": {
    "en": "Settings",
    "ar": "الإعدادات",
    "nl": "",
    "fr": "",
    "de": ""
  },
  "platform.common.ShowAll": {
    "nl": "Toon Alles",
    "ar": "إظهار الكل",
    "de": "Alles anzeigen",
    "fr": "tout afficher",
    "en": "Show All"
  },
  "platform.common.size": {
    "en": "Size",
    "ar": "الحجم",
    "nl": "",
    "fr": "",
    "de": ""
  },
  "platform.common.size.large": {
    "en": "Large",
    "ar": "كبير",
    "nl": "",
    "fr": "",
    "de": ""
  },
  "platform.common.size.medium": {
    "en": "Medium",
    "ar": "متوسط",
    "nl": "",
    "fr": "",
    "de": ""
  },
  "platform.common.size.small": {
    "en": "Small",
    "ar": "صغير",
    "nl": "",
    "fr": "",
    "de": ""
  },
  "platform.common.sourceText": {
    "en": "Source",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.common.success": {
    "en": "Success",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.common.tags": {
    "en": "Tags",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.common.title": {
    "en": "Title",
    "ar": "العنوان",
    "nl": "",
    "fr": "",
    "de": ""
  },
  "platform.common.type": {
    "en": "Type",
    "ar": "النوع",
    "nl": "",
    "fr": "",
    "de": ""
  },
  "platform.common.typescript_code": {
    "en": "Typescript Code",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.common.unity_code": {
    "en": "Unity Code",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.common.view_mode": {
    "en": "View Mode",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.debug.apidebugpanel.api_config": {
    "en": "API Config",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.debug.apidebugpanel.click_log_environment_to_check_if_environment_is_configured_correctly": {
    "en": "Click \"Log Environment\" to check if environment is configured correctly",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.debug.apidebugpanel.click_start_api_monitoring_to_see_all_api_calls_in_browser_console": {
    "en": "Click \"Start API Monitoring\" to see all API calls in browser console",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.debug.apidebugpanel.click_test_api_connection_to_test_if_the_api_is_reachable": {
    "en": "Click \"Test API Connection\" to test if the API is reachable",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.debug.apidebugpanel.common_fixes": {
    "en": "Common Fixes:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.debug.apidebugpanel.cors_error": {
    "en": "CORS Error:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.debug.apidebugpanel.current_user": {
    "en": "Current User",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.debug.apidebugpanel.debug_instructions": {
    "en": "Debug Instructions:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.debug.apidebugpanel.environment": {
    "en": "Environment",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.debug.apidebugpanel.environment_mismatch": {
    "en": "Environment Mismatch:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.debug.apidebugpanel.network_issues": {
    "en": "Network Issues:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.debug.apidebugpanel.open_browser_console_f12_to_see_detailed_logs": {
    "en": "Open browser console (F12) to see detailed logs",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.debug.apidebugpanel.token_issues": {
    "en": "Token Issues:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.debug.apidebugpanel.try_to_reproduce_the_failed_to_fetch_user_error_while_monitoring_is_active": {
    "en": "Try to reproduce the \"failed to fetch user\" error while monitoring is active",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.debug.apidebugpanel.wrong_api_url": {
    "en": "Wrong API URL:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.document-writer.documentdisplayblock.delete_block": {
    "en": "Delete block",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.document-writer.editor.delete_block": {
    "en": "Delete block",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.document-writer.editor.type": {
    "en": "Type ",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.document-writer.simplifiedexample.current_data_structure": {
    "en": "Current Data Structure:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.document-writer.simplifiedexample.simplified_document_writer_example": {
    "en": "Simplified Document Writer Example",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.editor.bubblemenuhelpers.bold": {
    "en": "Bold",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.editor.bubblemenuhelpers.highlight_text": {
    "en": "Highlight Text",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.editor.bubblemenuhelpers.highlight_text_2": {
    "en": "Highlight Text",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.editor.bubblemenuhelpers.no_color": {
    "en": "No Color",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.editor.bubblemenuhelpers.remove_highlight_item": {
    "en": "Remove highlight item",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.editor.bubblemenuhelpers.search_highlight_items": {
    "en": "Search highlight items...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.editor.bubblemenuhelpers.toggle_highlight_magic": {
    "en": "Toggle highlight (Magic)",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.editor.documentblock.loading_document_data": {
    "en": "Loading document data...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.editor.documentblock.preparing_form": {
    "en": "Preparing form...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.editor.highlightcontextmenu.highlight": {
    "en": "Highlight",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.editor.highlightcontextmenu.open_in_tab": {
    "en": "Open in tab",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.editor.highlightcontextmenu.unhighlight": {
    "en": "Unhighlight",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.editor.sortableblock.add_new_block_below": {
    "en": "Add new block below",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.editor.sortableblock.add_new_block_below_title": {
    "en": "Add new block below",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.editor.sortableblock.add_new_block_below_title_2": {
    "en": "Add new block below",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.editor.sortableblock.add_new_block_below_title_2_3": {
    "en": "Add new block below",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.editor.sortableblock.remove_block": {
    "en": "Remove block",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.editor.sortableblock.remove_block_title": {
    "en": "Remove block",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.editor.sortableblock.remove_block_title_2": {
    "en": "Remove block",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.editor.sortableblock.remove_block_title_2_3": {
    "en": "Remove block",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.editor.tabbedfileuploadercomponent.full_preview": {
    "en": "Full preview",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.editor.tabbedfileuploadercomponent.full_preview_2": {
    "en": "Full preview",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.editor.tabbedfileuploadercomponent.full_preview_2_3": {
    "en": "Full preview",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.editor.tabbedfileuploadercomponent.image_could_not_be_loaded": {
    "en": "Image could not be loaded",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.editor.tabbedfileuploadercomponent.image_preview": {
    "en": "Image preview",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.editor.tabbedfileuploadercomponent.image_preview_2": {
    "en": "Image preview",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.editor.tabbedfileuploadercomponent.image_url": {
    "en": "Image URL",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.editor.tabbedfileuploadercomponent.link_preview": {
    "en": "Link preview",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.editor.tabbedfileuploadercomponent.no_images_in_library": {
    "en": "No images in library",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.editor.tabbedfileuploadercomponent.select_an_image_from_your_library": {
    "en": "Select an image from your library:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.editor.tabbedfileuploadercomponent.selected": {
    "en": "Selected",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.editor.tabbedfileuploadercomponent.selected_from_library": {
    "en": "Selected from library",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.editor.tabbedfileuploadercomponent.upload_some_images_first": {
    "en": "Upload some images first",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ErrorBoundary.errorboundary.redirecting": {
    "en": "Redirecting...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.finishProfile_Parts.step0.enter_your_password": {
    "en": "Enter your password",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.finishProfile_Parts.step0.re_enter_your_password": {
    "en": "Re-enter your password",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.finishProfile_Parts.step1.choose_a_username": {
    "en": "Choose a username",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.finishProfile_Parts.step1.enter_your_first_name": {
    "en": "Enter your first name",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.finishProfile_Parts.step1.enter_your_last_name": {
    "en": "Enter your last name",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.finishProfile_Parts.step2.enter_8_character_code": {
    "en": "Enter 8-character code",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.finishProfile_Parts.step2.enter_your_company_name": {
    "en": "Enter your company name",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.finishProfile_Parts.step2.validating_code": {
    "en": "Validating code...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.finishProfile_Parts.step2.valid_code": {
    "en": "Valid code!",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.finishProfile_Parts.step3.company_name": {
    "en": "Company Name:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.finishProfile_Parts.step3.invitation_code": {
    "en": "Invitation Code:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.finishProfile_Parts.step3.note": {
    "en": "Note:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.finishProfile_Parts.step3.note_2": {
    "en": "Note:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.general.login.locanest_collection": {
    "en": "LocaNest Collection",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.general.login.login": {
    "en": "Login",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.general.tabcontext.unsaved_changes": {
    "en": "Unsaved Changes",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.graphs.entityrelationshipgraph.after_breaking_all_cycles_dag_mode_will_become_available": {
    "en": "After breaking all cycles, DAG mode will become available",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.graphs.entityrelationshipgraph.bottom_up": {
    "en": "Bottom-Up",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.graphs.entityrelationshipgraph.circular_dependencies": {
    "en": "Circular Dependencies",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.graphs.entityrelationshipgraph.circular_layout": {
    "en": "Circular Layout",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.graphs.entityrelationshipgraph.circular_references_detected": {
    "en": "Circular References Detected",
    "ar": "تم الكشف عن مراجع دائرية",
    "nl": "",
    "fr": "",
    "de": ""
  },
  "platform.graphs.entityrelationshipgraph.click_on_any_entity_in_a_cycle_to_navigate_to_it": {
    "en": "Click on any entity in a cycle to navigate to it",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.graphs.entityrelationshipgraph.dag_modes_disabled": {
    "en": "DAG modes disabled",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.graphs.entityrelationshipgraph.dag_mode_unavailable": {
    "en": "DAG Mode Unavailable",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.graphs.entityrelationshipgraph.default_layout": {
    "en": "Default Layout",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.graphs.entityrelationshipgraph.dismiss": {
    "en": "Dismiss",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.graphs.entityrelationshipgraph.entity_types": {
    "en": "Entity Types",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.graphs.entityrelationshipgraph.filtering_direct_connections": {
    "en": "Filtering: Direct connections",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.graphs.entityrelationshipgraph.fit_graph_to_screen": {
    "en": "Fit graph to screen",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.graphs.entityrelationshipgraph.force_2d_view": {
    "en": "Force 2D View",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.graphs.entityrelationshipgraph.force_3d_view": {
    "en": "Force 3D View",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.graphs.entityrelationshipgraph.force_directed": {
    "en": "Force-Directed",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.graphs.entityrelationshipgraph.grid_layout": {
    "en": "Grid Layout",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.graphs.entityrelationshipgraph.hierarchical": {
    "en": "Hierarchical",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.graphs.entityrelationshipgraph.horizontal_tree": {
    "en": "Horizontal Tree",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.graphs.entityrelationshipgraph.how_to_fix": {
    "en": "How to Fix",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.graphs.entityrelationshipgraph.left_right": {
    "en": "Left-Right",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.graphs.entityrelationshipgraph.no_relationships_found": {
    "en": "No relationships found",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.graphs.entityrelationshipgraph.radial": {
    "en": "Radial",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.graphs.entityrelationshipgraph.radial_inward": {
    "en": "Radial Inward",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.graphs.entityrelationshipgraph.radial_layout": {
    "en": "Radial Layout",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.graphs.entityrelationshipgraph.radial_outward": {
    "en": "Radial Outward",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.graphs.entityrelationshipgraph.react_flow_view": {
    "en": "React Flow View",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.graphs.entityrelationshipgraph.reorganize_your_entity_structure_to_be_hierarchical": {
    "en": "Reorganize your entity structure to be hierarchical",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.graphs.entityrelationshipgraph.review_and_remove_unnecessary_relationships": {
    "en": "Review and remove unnecessary relationships",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.graphs.entityrelationshipgraph.right_left": {
    "en": "Right-Left",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.graphs.entityrelationshipgraph.spread_layout": {
    "en": "Spread Layout",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.graphs.entityrelationshipgraph.tight_layout": {
    "en": "Tight Layout",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.graphs.entityrelationshipgraph.top_down": {
    "en": "Top-Down",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.graphs.entityrelationshipgraph.tree": {
    "en": "Tree",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.graphs.entityrelationshipgraph.vertical_tree": {
    "en": "Vertical Tree",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.images.imageuploaddialog.eg_hero_banner": {
    "en": "e.g., Hero Banner",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.images.imageuploaddialog.eg_hero_banner_placeholder": {
    "en": "e.g., hero-banner",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.images.imageuploaddialog.name_your_images": {
    "en": "Name Your Images",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ink-editor.inkeditortoolbar.ink_visual_editor": {
    "en": "Ink Visual Editor",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ink-editor.inktexteditor.ink_script": {
    "en": "Ink Script",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ink-editor.knotlayerselector.all_nodes": {
    "en": "All Nodes",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ink-editor.knotlayerselector.no_knots_found": {
    "en": "No knots found",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ink-editor.knotlayerselector.show_all_content": {
    "en": "Show all content",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ink-editor.nodepalette.choice": {
    "en": "Choice",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ink-editor.nodepalette.condition": {
    "en": "Condition",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ink-editor.nodepalette.content": {
    "en": "Content",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ink-editor.nodepalette.function": {
    "en": "Function",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ink-editor.nodepalette.gather": {
    "en": "Gather",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ink-editor.nodepalette.knot": {
    "en": "Knot",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ink-editor.nodepalette.stitch": {
    "en": "Stitch",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ink-editor.nodepalette.variable": {
    "en": "Variable",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ink-editor.nodes.choice_text": {
    "en": "Choice text...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ink-editor.nodes.condition": {
    "en": "CONDITION",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ink-editor.nodes.content": {
    "en": "CONTENT",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ink-editor.nodes.focus_this_layer": {
    "en": "Focus this layer",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ink-editor.nodes.function": {
    "en": "FUNCTION",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ink-editor.nodes.gather": {
    "en": "GATHER",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ink-editor.nodes.stitch": {
    "en": "STITCH",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ink-editor.nodes.text_content": {
    "en": "Text content...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ink-editor.nodes.x_5": {
    "en": "x > 5",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.000000": {
    "en": "#000000",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.action_handlers": {
    "en": "Action Handlers",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.action_handlers_2": {
    "en": "Action Handlers",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.add_element": {
    "en": "Add Element",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.add_item": {
    "en": "Add item",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.add_items": {
    "en": "Add items",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.add_widget": {
    "en": "Add widget",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.add_widget_2": {
    "en": "Add widget",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.add_widget_2_3": {
    "en": "Add widget",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.add_widget_2_3_4": {
    "en": "Add widget",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.add_widget_2_3_4_5": {
    "en": "Add widget",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.add_widget_2_3_4_5_6": {
    "en": "Add widget",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.add_widget_2_3_4_5_6_7": {
    "en": "Add widget",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.add_widget_2_3_4_5_6_7_8": {
    "en": "Add widget",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.add_widget_2_3_4_5_6_7_8_9": {
    "en": "Add widget",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.background_color": {
    "en": "Background Color",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.black": {
    "en": "Black",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.button_text": {
    "en": "Button Text",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.button_text_label": {
    "en": "Button Text",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.collapse_icon": {
    "en": "Collapse Icon",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.column_label": {
    "en": "Column label",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.common_properties": {
    "en": "Common Properties",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.custom_color": {
    "en": "Custom Color",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.data_source": {
    "en": "Data Source",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.delete_handler": {
    "en": "Delete Handler",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.delete_handler_label": {
    "en": "Delete Handler",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.display_widget_title": {
    "en": "Display widget title",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.duplicate_handler": {
    "en": "Duplicate Handler",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.duplicate_handler_label": {
    "en": "Duplicate Handler",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.edit_element": {
    "en": "Edit element",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.edit_handler": {
    "en": "Edit Handler",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.edit_handler_label": {
    "en": "Edit Handler",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.eg_location_character": {
    "en": "e.g. Location, Character",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.element_type": {
    "en": "Element Type",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.enter_label": {
    "en": "Enter label",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.enter_list_title": {
    "en": "Enter list title",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.enter_number_of_items": {
    "en": "Enter number of items",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.enter_subtitle": {
    "en": "Enter subtitle",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.enter_table_title": {
    "en": "Enter table title",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.enter_table_title_placeholder": {
    "en": "Enter table title",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.enter_title_text": {
    "en": "Enter title text",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.enter_tms_table_title": {
    "en": "Enter TMS table title",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.enter_trend_eg_52": {
    "en": "Enter trend (e.g., +5.2%)",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.enter_value": {
    "en": "Enter value",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.expandable_content_settings": {
    "en": "Expandable Content Settings",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.expand_icon": {
    "en": "Expand Icon",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.extra_large": {
    "en": "Extra Large",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.fa_chevron_down": {
    "en": "fa-chevron-down",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.fa_chevron_right": {
    "en": "fa-chevron-right",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.ffffff": {
    "en": "#ffffff",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.gradient": {
    "en": "Gradient",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.grid_size": {
    "en": "Grid size:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.handler_function": {
    "en": "Handler Function",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.handler_function_label": {
    "en": "Handler Function",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.legacy_column_configuration": {
    "en": "Legacy Column Configuration",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.manual_value": {
    "en": "Manual Value",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.manual_value_label": {
    "en": "Manual Value",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.none": {
    "en": "None",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.number_of_items": {
    "en": "Number of Items",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.published": {
    "en": "Published",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.remove_element": {
    "en": "Remove element",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.required_tags_comma_separated": {
    "en": "Required Tags (comma-separated)",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.search_cards_by_title_creator_description_or_tags": {
    "en": "Search cards by title, creator, description, or tags...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.select_data_source": {
    "en": "Select data source",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.select_element_type": {
    "en": "Select element type",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.select_field": {
    "en": "Select field",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.select_shadow_style": {
    "en": "Select shadow style",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.select_size": {
    "en": "Select size",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.shadow_color": {
    "en": "Shadow Color",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.shadow_style": {
    "en": "Shadow Style",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.show_add_new_button": {
    "en": "Show \"Add New\" Button",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.show_add_new_button_label": {
    "en": "Show \"Add New\" Button",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.show_title": {
    "en": "Show Title",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.single_element_slot": {
    "en": "Single element slot",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.slot_1": {
    "en": "Slot 1",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.slot_1_2": {
    "en": "Slot 1",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.slot_1_2_3": {
    "en": "Slot 1",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.slot_2": {
    "en": "Slot 2",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.slot_2_2": {
    "en": "Slot 2",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.slot_2_2_3": {
    "en": "Slot 2",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.slot_3": {
    "en": "Slot 3",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.slot_3_2": {
    "en": "Slot 3",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.slot_4": {
    "en": "Slot 4",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.status": {
    "en": "Status:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.subtitle": {
    "en": "Subtitle",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.table": {
    "en": "Table",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.title_text": {
    "en": "Title Text",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.trend": {
    "en": "Trend",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.element-layout.widget_properties": {
    "en": "Widget Properties",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.page-layout.add_new_row": {
    "en": "Add New Row",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.page-layout.background_color": {
    "en": "Background Color",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.page-layout.choose_what_type_of_widget_to_add_to_the_new_row": {
    "en": "Choose what type of widget to add to the new row",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.page-layout.drag_to_reorder": {
    "en": "Drag to reorder",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.page-layout.enter_row_title": {
    "en": "Enter row title",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.page-layout.extra_large": {
    "en": "Extra Large",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.page-layout.ffffff": {
    "en": "#ffffff",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.page-layout.filter_by_tags": {
    "en": "Filter by tags:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.page-layout.gap_between_elements": {
    "en": "Gap Between Elements",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.page-layout.grid_size": {
    "en": "Grid size:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.page-layout.layout_configuration": {
    "en": "Layout Configuration",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.page-layout.no_cards_found": {
    "en": "No cards found",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.page-layout.no_configuration_available": {
    "en": "No configuration available",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.page-layout.number_of_slots": {
    "en": "Number of Slots",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.page-layout.padding": {
    "en": "Padding",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.page-layout.remove_row": {
    "en": "Remove row",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.page-layout.row_information": {
    "en": "Row Information",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.page-layout.row_settings": {
    "en": "Row Settings",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.page-layout.row_title": {
    "en": "Row Title",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.page-layout.search_cards_by_title_creator_description_or_tags": {
    "en": "Search cards by title, creator, description, or tags...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.page-layout.search_widgets": {
    "en": "Search widgets...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.page-layout.select_widget_type": {
    "en": "Select Widget Type",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.side-bars.add_folder_or_item": {
    "en": "Add folder or item",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.side-bars.data_settings_content": {
    "en": "Data settings content",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.side-bars.enter_folder_name": {
    "en": "Enter folder name...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.side-bars.loading_folders": {
    "en": "Loading folders...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.side-bars.open_right_sidebar": {
    "en": "Open Right Sidebar",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.side-bars.security_settings_content": {
    "en": "Security settings content",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.side-bars.theme_settings_content": {
    "en": "Theme settings content",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.side-bars.toggle_folder_structure": {
    "en": "Toggle folder structure",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.side-bars.toggle_folder_structure_title": {
    "en": "Toggle folder structure",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.side-bars.toggle_sidebar": {
    "en": "Toggle Sidebar",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.side-bars.toggle_sidebar_label": {
    "en": "Toggle Sidebar",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.side-bars.toggle_sidebar_title": {
    "en": "Toggle Sidebar",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.side-bars.user_settings_content": {
    "en": "User settings content",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.splitview.close_split_view": {
    "en": "Close split view",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.splitview.close_tab": {
    "en": "Close tab",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.structure-menu.graph_navigation": {
    "en": "Graph Navigation",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.structure-menu.graph_navigation_2": {
    "en": "Graph Navigation",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.structure-menu.last_edited_by": {
    "en": "Last Edited by",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.structure-menu.live": {
    "en": "Live",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.structure-menu.no_connections_found": {
    "en": "No connections found",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.structure-menu.no_connections_found_2": {
    "en": "No connections found",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.structure-menu.no_highlighted_items_found": {
    "en": "No highlighted items found",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.structure-menu.no_version_history_available": {
    "en": "No version history available",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.structure-menu.objects": {
    "en": "Objects",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.structure-menu.select_a_library_object_to_view_version_history": {
    "en": "Select a library object to view version history",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.structure-menu.select_an_item_to_view_basic_information": {
    "en": "No Basic information available",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.structure-menu.select_a_section_to_view_details": {
    "en": "Select node to view",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.structure-menu.select_a_template_to_view_version_history": {
    "en": "Select a template to view version history",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.layout.structure-menu.total_connections": {
    "en": "Total Connections:",
    "ar": "إجمالي الاتصالات",
    "nl": "Aantal Connecties",
    "fr": "",
    "de": ""
  },
  "platform.layout.structure-menu.total_items": {
    "en": "Total Items:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.object-version.objectversionhistorypanel.no_version_history_available": {
    "en": "No version history available",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.object-version.objectversionhistorypanel.versions_will_appear_after_you_save_changes_to_this_item": {
    "en": "Versions will appear after you save changes to this item",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.owner.projectselector.select_project": {
    "en": "Select project",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.documentationpage.all_templates": {
    "en": "All Templates",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.documentationpage.fields": {
    "en": "Fields",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.documentationpage.loading_documentation": {
    "en": "Loading documentation...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.documentationpage.search_templates": {
    "en": "Search templates...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.documentationpage.sections": {
    "en": "Sections",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.documentationpage.template_documentation": {
    "en": "Template Documentation",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.documentationpage.template_structure": {
    "en": "Template Structure",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.documentationpage.version": {
    "en": "Version",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.documentdetailpage.cancel_editing": {
    "en": "Cancel editing",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.documentdetailpage.click_to_edit_title": {
    "en": "Click to edit title",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.documentdetailpage.document_json_data": {
    "en": "Document JSON Data",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.documentdetailpage.enter_document_name": {
    "en": "Enter document name",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.documentdetailpage.glossary_items": {
    "en": "Glossary Items:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.documentdetailpage.keys": {
    "en": "Keys:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.documentdetailpage.save_as_a_new_document": {
    "en": "Save as a new document",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.documentdetailpage.save_as_new_document": {
    "en": "Save As New Document",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.documentdetailpage.save_title": {
    "en": "Save title",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.documentdetailpage.summary_by_type": {
    "en": "Summary by Type:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.documentdetailpage.text": {
    "en": "Text:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.documentdetailpage.text_content_analysis": {
    "en": "Text Content Analysis",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.finishprofilepage.loading_account_info": {
    "en": "Loading account info...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.finishprofilepage.setting_up_your_session": {
    "en": "Setting up your session...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.imagespage.created": {
    "en": "Created",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.imagespage.display_name": {
    "en": "Display name",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.imagespage.display_name_placeholder": {
    "en": "Display name",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.imagespage.image_key": {
    "en": "image-key",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.imagespage.image_key_placeholder": {
    "en": "image-key",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.imagespage.name_key": {
    "en": "Name & Key",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.imagespage.please_select_a_game_to_view_images": {
    "en": "Please select a game to view images",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.imagespage.search_images": {
    "en": "Search images...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.imagespage.unused": {
    "en": "Unused",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.imagespage.usage": {
    "en": "Usage",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.imagespage.used_in": {
    "en": "Used in:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.Library": {
    "nl": "Bibliotheek",
    "ar": "مكتبة",
    "fr": "Bibliothèque",
    "de": "Bibliothek",
    "en": "Libary"
  },
  "platform.pages.login.confirm_password": {
    "en": "Confirm Password",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.login.email_address": {
    "en": "Email address",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.login.invitation_code_required": {
    "en": "INVITATION CODE (REQUIRED)",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.login.keep_me_logged_in": {
    "en": "Keep me logged in",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.notfound.oops_page_not_found": {
    "en": "Oops! Page not found",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.notfound.redirecting_to_home": {
    "en": "Redirecting to home...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.relationshippage.clean_up_orphaned_relationships": {
    "en": "Clean up orphaned relationships",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.relationshippage.error_loading_relationships": {
    "en": "Error loading relationships",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.relationshippage.please_select_a_game_to_view_relationships": {
    "en": "Please select a game to view relationships",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.relationshippage.process_all_library_objects_and_documents": {
    "en": "Process all library objects and documents",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.relationshippage.recreate_all_entity_relationships": {
    "en": "Recreate all entity relationships",
    "ar": "إعادة إنشاء جميع علاقات الكيانات",
    "nl": "",
    "fr": "",
    "de": ""
  },
  "platform.pages.settingspage.this_section_is_not_yet_implemented": {
    "en": "This section is not yet implemented.",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.Templates": {
    "ar": "قوالب",
    "de": "Vorlagen",
    "fr": "Modèles",
    "nl": "Sjablonen",
    "en": "Templates"
  },
  "platform.pages.test_pages.add_new_highlight_key": {
    "en": "Add New Highlight Key",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.admins": {
    "en": "Admins",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.after_10_increments_000011": {
    "en": "After 10 increments: 0.00011",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.after_1_increment_000002": {
    "en": "After 1 increment: 0.00002",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.after_2_increments_000003": {
    "en": "After 2 increments: 0.00003",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.async_resolved": {
    "en": "Async Resolved:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.async_resolved_2": {
    "en": "Async Resolved:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.automatic_highlighting": {
    "en": "Automatic Highlighting",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.available_blueprints": {
    "en": "Available Blueprints:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.blueprint": {
    "en": "Blueprint:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.built_in": {
    "en": "Built-in",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.choose_a_user_from_the_game": {
    "en": "Choose a user from the game...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.company_members": {
    "en": "Company Members:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.company_members_test": {
    "en": "Company Members Test",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.contributors": {
    "en": "Contributors",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.current_blocks_state": {
    "en": "Current Blocks State:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.current_data": {
    "en": "Current Data",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.current_game": {
    "en": "Current Game",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.current_game_title": {
    "en": "Current Game",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.current_highlight_items": {
    "en": "Current Highlight Items",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.current_version": {
    "en": "Current Version",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.custom": {
    "en": "Custom",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.custom_user_id_resolution_test": {
    "en": "Custom User ID Resolution Test",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.description": {
    "en": "Description:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.document_block_test": {
    "en": "Document Block Test",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.eg_d5c06578_70ca_4f32_9023_24170c6620bf66a20e37_353d_4646_8d22_da19e8df5570": {
    "en": "e.g., d5c06578-70ca-4f32-9023-24170c6620bf,66a20e37-353d-4646-8d22-da19e8df5570",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.enter_highlight_key": {
    "en": "Enter highlight key...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.expected_behavior": {
    "en": "Expected Behavior",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.game_id": {
    "en": "Game ID:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.game_members": {
    "en": "Game Members:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.game_members_test": {
    "en": "Game Members Test",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.game_user_selector": {
    "en": "Game User Selector",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.game_users_list": {
    "en": "Game Users List",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.game_users_test_page": {
    "en": "Game Users Test Page",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.glossary": {
    "en": "Glossary",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.glossary_item_parser_test": {
    "en": "Glossary Item Parser Test",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.glossary_items": {
    "en": "Glossary Items:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.glossary_items_title": {
    "en": "Glossary Items",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.highlightdataservice_items_built_in": {
    "en": "HighlightDataService Items (Built-in)",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.highlight_types": {
    "en": "Highlight Types",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.how_to_use_highlighting": {
    "en": "How to Use Highlighting",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.individual_user_lookup": {
    "en": "Individual User Lookup",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.loading_game_users": {
    "en": "Loading game users...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.loading_user_data": {
    "en": "Loading user data...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.manual_highlighting": {
    "en": "Manual Highlighting",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.members_resolution_test_page": {
    "en": "Members Resolution Test Page",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.name": {
    "en": "Name:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.no_floating_point_precision_errors": {
    "en": "No floating point precision errors",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.no_game_selected": {
    "en": "No game selected",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.no_glossary_items_found_create_one_to_get_started": {
    "en": "No glossary items found. Create one to get started!",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.object_selector_test_page": {
    "en": "Object Selector Test Page",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.raw_members_data": {
    "en": "Raw Members Data:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.raw_members_data_2": {
    "en": "Raw Members Data:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.resolution_result": {
    "en": "Resolution Result:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.run_test": {
    "en": "Run Test",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.selected_company": {
    "en": "Selected Company:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.selected_game": {
    "en": "Selected Game:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.selected_user_id": {
    "en": "Selected User ID:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.select_user": {
    "en": "Select User:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.starting_version_000001": {
    "en": "Starting version: 0.00001",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.sync_resolved": {
    "en": "Sync Resolved:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.sync_resolved_2": {
    "en": "Sync Resolved:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.test_results": {
    "en": "Test Results",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.test_the_highlighting_functionality_in_the_textblock_component": {
    "en": "Test the highlighting functionality in the TextBlock component",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.text_editor_with_highlighting": {
    "en": "Text Editor with Highlighting",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.text_highlighting_test_page": {
    "en": "Text Highlighting Test Page",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.total_keys": {
    "en": "Total Keys",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.total_users": {
    "en": "Total Users",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.translators": {
    "en": "Translators",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.type_or_paste_text_here_to_see_highlighting_in_action": {
    "en": "Type or paste text here to see highlighting in action...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.user_statistics": {
    "en": "User Statistics",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.test_pages.version_increment_test": {
    "en": "Version Increment Test",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.tutorialpage.for_all_roles": {
    "en": "For all roles",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.tutorialpage.loading_tutorial": {
    "en": "Loading tutorial...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.tutorialpage.platform_tutorial": {
    "en": "Platform Tutorial",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.tutorialpage.tasks_will_automatically_be_marked_complete_as_you_use_the_platform": {
    "en": "Tasks will automatically be marked complete as you use the platform.",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.tutorialpage.you_can_return_to_this_tutorial_anytime_from_the_sidebar_menu": {
    "en": "You can return to this tutorial anytime from the sidebar menu.",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.tutorialpage.your_progress": {
    "en": "Your Progress",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.uipage.add_some_html_to_see_the_preview": {
    "en": "Add some HTML to see the preview",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.uipage.click_me": {
    "en": "Click Me",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.uipage.click_me_button": {
    "en": "Click Me",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.uipage.click_me_button_2": {
    "en": "Click Me",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.uipage.eg_button_component_card_layout": {
    "en": "e.g., Button Component, Card Layout...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.uipage.enter_your_css_here": {
    "en": "Enter your CSS here...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.uipage.enter_your_html_here": {
    "en": "Enter your HTML here...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.uipage.export_ui_for_unity_ui_toolkit": {
    "en": "Export UI for Unity UI Toolkit",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.uipage.html": {
    "en": "HTML",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.uipage.iframe_failed_to_load": {
    "en": "Iframe failed to load",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.uipage.image_key_not_found_imagekey": {
    "en": "Image key not found: ${imageKey}",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.uipage.images": {
    "en": "Images:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.uipage.language": {
    "en": "Language:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.uipage.load_ui_template": {
    "en": "Load UI Template",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.uipage.locakey_not_found": {
    "en": "LocaKey not found",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.uipage.locakeys": {
    "en": "LocaKeys:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.uipage.no_content_to_preview": {
    "en": "No content to preview",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.uipage.save_as_a_new_template_or_with_a_different_name": {
    "en": "Save as a new template or with a different name",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.uipage.save_ui_template": {
    "en": "Save UI Template",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.uipage.select_language": {
    "en": "Select language",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.uipage.showhide_size_boxes_for_constrained_elements": {
    "en": "Show/hide size boxes for constrained elements",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.uipage.template_name": {
    "en": "Template Name",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.pages.uipage.the_preview_iframe_encountered_an_error_heres_the_raw_html_content": {
    "en": "The preview iframe encountered an error. Here's the raw HTML content:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.apikeyssection.api_key": {
    "en": "API Key",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.apikeyssection.api_key_generated_successfully": {
    "en": "API Key Generated Successfully",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.apikeyssection.api_key_label": {
    "en": "API Key",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.apikeyssection.api_keys": {
    "en": "API Keys",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.apikeyssection.api_secret": {
    "en": "API Secret",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.apikeyssection.copy_both_the_api_key_and_secret": {
    "en": "Copy both the API key and secret",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.apikeyssection.disable_offline_mode": {
    "en": "Disable offline mode",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.apikeyssection.eg_vs_code_plugin": {
    "en": "e.g., VS Code Plugin",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.apikeyssection.generate_an_api_key_above": {
    "en": "Generate an API key above",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.apikeyssection.in_vs_code_go_to_settings_extensions_locanest": {
    "en": "In VS Code, go to Settings → Extensions → LocaNest",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.apikeyssection.key_name": {
    "en": "Key Name",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.apikeyssection.last_used": {
    "en": "Last Used",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.apikeyssection.making_api_requests": {
    "en": "Making API Requests",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.apikeyssection.never_commit_api_keys_to_version_control": {
    "en": "Never commit API keys to version control",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.apikeyssection.no_api_key": {
    "en": "No API Key",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.apikeyssection.paste_your_api_key_and_secret": {
    "en": "Paste your API key and secret",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.apikeyssection.revoke_api_key": {
    "en": "Revoke API Key",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.apikeyssection.revoke_keys_immediately_if_compromised": {
    "en": "Revoke keys immediately if compromised",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.apikeyssection.rotate_keys_periodically": {
    "en": "Rotate keys periodically",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.apikeyssection.security_best_practices": {
    "en": "Security Best Practices",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.apikeyssection.set_your_game_id": {
    "en": "Set your Game ID",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.apikeyssection.store_secrets_in_environment_variables": {
    "en": "Store secrets in environment variables",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.apikeyssection.using_api_keys": {
    "en": "Using API Keys",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.apikeyssection.vs_code_plugin_setup": {
    "en": "VS Code Plugin Setup",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.creategamemodal.create_new_game": {
    "en": "Create New Game",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.creategamemodal.enter_a_description_for_the_game": {
    "en": "Enter a description for the game",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.creategamemodal.enter_game_name": {
    "en": "Enter game name",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.deletegamemodal.delete_game": {
    "en": "Delete Game",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.environmentsettingssection.always_start_with_the_same_project": {
    "en": "Always start with the same project",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.environmentsettingssection.ask_before_closing_with_unsaved_changes": {
    "en": "Ask before closing with unsaved changes",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.environmentsettingssection.auto_save": {
    "en": "Auto-save:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.environmentsettingssection.collapsed_by_default": {
    "en": "Collapsed by Default",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.environmentsettingssection.confirm_before_leaving": {
    "en": "Confirm Before Leaving",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.environmentsettingssection.current_configuration_summary": {
    "en": "Current Configuration Summary",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.environmentsettingssection.default_project": {
    "en": "Default Project:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.environmentsettingssection.default_project_behavior": {
    "en": "Default Project Behavior",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.environmentsettingssection.disabled": {
    "en": "Disabled",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.environmentsettingssection.display_navigation_breadcrumbs": {
    "en": "Display navigation breadcrumbs",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.environmentsettingssection.display_tooltips_on_hover": {
    "en": "Display tooltips on hover",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.environmentsettingssection.display_welcome_screen_on_startup": {
    "en": "Display welcome screen on startup",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.environmentsettingssection.enable_keyboard_navigation_shortcuts": {
    "en": "Enable keyboard navigation shortcuts",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.environmentsettingssection.hidden": {
    "en": "Hidden",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.environmentsettingssection.keyboard_shortcuts": {
    "en": "Keyboard Shortcuts",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.environmentsettingssection.navigation_ui_preferences": {
    "en": "Navigation & UI Preferences",
    "ar": "تفضيلات التنقل وواجهة المستخدم",
    "nl": "",
    "fr": "",
    "de": ""
  },
  "platform.settings.environmentsettingssection.open_last_used_project": {
    "en": "Open last used project",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.environmentsettingssection.open_specific_project": {
    "en": "Open specific project",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.environmentsettingssection.resume_where_you_left_off": {
    "en": "Resume where you left off",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.environmentsettingssection.select_a_company": {
    "en": "Select a company...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.environmentsettingssection.select_a_project": {
    "en": "Select a project...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.environmentsettingssection.show_breadcrumbs": {
    "en": "Show Breadcrumbs",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.environmentsettingssection.show_group": {
    "en": "Show Group",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.environmentsettingssection.show_tooltips": {
    "en": "Show Tooltips",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.environmentsettingssection.show_welcome_screen": {
    "en": "Show Welcome Screen",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.environmentsettingssection.sidebar": {
    "en": "Sidebar:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.environmentsettingssection.sidebar_customization": {
    "en": "Sidebar Customization",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.environmentsettingssection.start_with_sidebar_collapsed": {
    "en": "Start with sidebar collapsed",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.environmentsettingssection.visible_navigation_items": {
    "en": "Visible Navigation Items",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.environmentsettingssection.workspace_preferences": {
    "en": "Workspace Preferences",
    "ar": "تفضيلات مساحة العمل",
    "nl": "",
    "fr": "",
    "de": ""
  },
  "platform.settings.exporttemplatessection.all_templates": {
    "en": "All Templates",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.applies_to": {
    "en": "Applies To",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.blueprint_type": {
    "en": "Blueprint Type",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.code_type": {
    "en": "Code Type",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.common_variables": {
    "en": "Common Variables",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.custom": {
    "en": "Custom",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.default_value": {
    "en": "Default Value",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.description_of_this_template": {
    "en": "Description of this template...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.description_optional": {
    "en": "Description (optional)",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.edit_template": {
    "en": "Edit Template",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.enter_template_content_with_placeholders": {
    "en": "Enter template content with placeholders...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.enter_template_content_with_placeholders_placeholder": {
    "en": "Enter template content with placeholders...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.example_usage_in_function": {
    "en": "Example usage in function:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.export_templates": {
    "en": "Export Templates",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.field_name": {
    "en": "Field Name",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.field_name_convention": {
    "en": "Field Name Convention",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.field_type_mappings": {
    "en": "Field Type Mappings",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.file_name": {
    "en": "File Name",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.file_name_convention": {
    "en": "File Name Convention",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.filenameluau": {
    "en": "{{FileName}}.luau",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.filename_pattern": {
    "en": "Filename Pattern",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.filename_pattern_label": {
    "en": "Filename Pattern",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.filename_pattern_label_2": {
    "en": "Filename Pattern",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.filename_pattern_label_2_3": {
    "en": "Filename Pattern",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.function_code": {
    "en": "Function Code",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.function_code_here": {
    "en": "function code here...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.function_name": {
    "en": "Function Name",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.game_engine": {
    "en": "Game Engine:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.godot": {
    "en": "Godot",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.instance_name": {
    "en": "Instance Name",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.instance_name_convention": {
    "en": "Instance Name Convention",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.location_in_package": {
    "en": "Location in Package",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.location_in_package_label": {
    "en": "Location in Package",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.location_in_package_label_2": {
    "en": "Location in Package",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.location_in_package_label_2_3": {
    "en": "Location in Package",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.my_custom_template": {
    "en": "My Custom Template",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.naming_conventions": {
    "en": "Naming Conventions",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.platform": {
    "en": "Platform",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.roblox": {
    "en": "Roblox",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.screamingsnakecase": {
    "en": "SCREAMING_SNAKE_CASE",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.screamingsnakecase_2": {
    "en": "SCREAMING_SNAKE_CASE",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.screamingsnakecase_2_3": {
    "en": "SCREAMING_SNAKE_CASE",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.screamingsnakecase_2_3_4": {
    "en": "SCREAMING_SNAKE_CASE",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.select_common_variables": {
    "en": "Select common variables...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.selective_templates": {
    "en": "Selective Templates",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.select_templates": {
    "en": "Select Templates",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.select_templates_placeholder": {
    "en": "Select templates...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.showing_templates_for": {
    "en": "Showing templates for:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.template_content": {
    "en": "Template Content",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.template_content_label": {
    "en": "Template Content",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.template_content_label_2": {
    "en": "Template Content",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.template_content_label_2_3": {
    "en": "Template Content",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.template_functions": {
    "en": "Template Functions",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.template_functions_label": {
    "en": "Template Functions",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.template_name": {
    "en": "Template Name",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.template_name_convention": {
    "en": "Template Name Convention",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.template_name_label": {
    "en": "Template Name *",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.templatenameluau": {
    "en": "{{TemplateName}}.luau",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.templates": {
    "en": "Templates",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.template_variables": {
    "en": "Template Variables",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.unity": {
    "en": "Unity",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.exporttemplatessection.what_this_function_does": {
    "en": "What this function does",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.gamessetupsection.choose_a_game": {
    "en": "Choose a game...",
    "nl": "Selecteer een game",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.gamessetupsection.danger_zone": {
    "en": "Danger Zone",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.gamessetupsection.enter_a_description_for_the_game": {
    "en": "Enter a description for the game",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.gamessetupsection.enter_the_game_name": {
    "en": "Enter the game name",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.gamessetupsection.no_games_available_in_this_company_create_a_new_game_or_contact_your_administrator": {
    "en": "No games available in this company. Create a new game or contact your administrator.",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.gamessetupsection.please_select_a_game_to_configure_its_settings": {
    "en": "Please select a game to configure its settings.",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.gamessetupsection.select_a_language": {
    "en": "Select a language...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.gamessetupsection.select_an_engine": {
    "en": "Select an engine...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.gamessetupsection.select_languages": {
    "en": "Select languages...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.gamessetupsection.use_companyuser_default": {
    "en": "Use company/user default...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.generalsetupsection.enter_the_company_name": {
    "en": "Enter the company name",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.importexportsection.all_documents_with_their_content": {
    "en": "All documents with their content",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.importexportsection.all_objects_glossary_items_with_their_data_and_metadata": {
    "en": "All objects (glossary items) with their data and metadata",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.importexportsection.all_templates_blueprints_with_field_definitions": {
    "en": "All templates (blueprints) with field definitions",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.importexportsection.all_text_strings_with_translations": {
    "en": "All text strings with translations",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.importexportsection.complete_export": {
    "en": "Complete Export:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.importexportsection.documents": {
    "en": "Documents",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.importexportsection.entity_relationships_showing_how_items_are_linked": {
    "en": "Entity relationships showing how items are linked",
    "ar": "علاقات الكيانات التي توضح كيفية ارتباط العناصر ببعضها البعض",
    "nl": "",
    "fr": "",
    "de": ""
  },
  "platform.settings.importexportsection.export_mode": {
    "en": "Export Mode",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.importexportsection.identifiers": {
    "en": "Identifiers:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.importexportsection.includes": {
    "en": "Includes:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.importexportsection.individual_exports": {
    "en": "Individual Exports:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.importexportsection.objects": {
    "en": "Objects",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.importexportsection.relationships": {
    "en": "Relationships:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.importexportsection.select_a_blueprint": {
    "en": "Select a blueprint",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.importexportsection.select_blueprint": {
    "en": "Select Blueprint",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.importexportsection.tags_and_type_definitions": {
    "en": "Tags and type definitions",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.importexportsection.templates": {
    "en": "Templates",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.importexportsection.texts": {
    "en": "Texts",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.importexportsection.timestamps": {
    "en": "Timestamps:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.invitationcodessection.admin": {
    "en": "Admin",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.invitationcodessection.contributor": {
    "en": "Contributor",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.invitationcodessection.copy_code": {
    "en": "Copy code",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.invitationcodessection.eg_paradox_team_external_translators": {
    "en": "e.g., Paradox Team, External Translators",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.invitationcodessection.how_it_works": {
    "en": "How it works:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.invitationcodessection.invitation_codes": {
    "en": "Invitation Codes",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.invitationcodessection.loading_codes": {
    "en": "Loading codes...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.invitationcodessection.no_games_available": {
    "en": "No games available",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.invitationcodessection.owner": {
    "en": "Owner",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.invitationcodessection.paradoxcom_paradoxse": {
    "en": "@paradox.com, @paradox.se",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.invitationcodessection.revoke_code": {
    "en": "Revoke code",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.permissionssection.built_in": {
    "en": "Built-in",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.permissionssection.built_in_2": {
    "en": "Built-in",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.permissionssection.describe_what_this_role_can_do": {
    "en": "Describe what this role can do",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.permissionssection.enter_role_name": {
    "en": "Enter role name",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.permissionssection.loading_roles": {
    "en": "Loading roles...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.permissionssection.new_role": {
    "en": "New Role",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.permissionssection.permission_categories": {
    "en": "Permission Categories:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.permissionssection.permissions": {
    "en": "Permissions",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.permissionssection.permission_summary": {
    "en": "Permission Summary",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.permissionssection.roles": {
    "en": "Roles",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.permissionssection.select_a_role": {
    "en": "Select a Role",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.permissionssection.total_roles": {
    "en": "Total Roles:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.permissionssection.total_users": {
    "en": "Total Users:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.profilesection.avatar": {
    "en": "Avatar",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.profilesection.basic_information": {
    "en": "Basic Information",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.profilesection.company_visible_to_company_members": {
    "en": "Company - Visible to company members",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.profilesection.display_when_you_were_last_active": {
    "en": "Display when you were last active",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.profilesection.display_your_email_in_your_profile": {
    "en": "Display your email in your profile",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.profilesection.email_notifications": {
    "en": "Email Notifications",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.profilesection.enter_your_display_name": {
    "en": "Enter your display name",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.profilesection.enter_your_username": {
    "en": "Enter your username",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.profilesection.get_notified_about_project_changes": {
    "en": "Get notified about project changes",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.profilesection.mac": {
    "en": "Mac:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.profilesection.marketing_emails": {
    "en": "Marketing Emails",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.profilesection.notification_settings": {
    "en": "Notification Settings",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.profilesection.preferences": {
    "en": "Preferences",
    "ar": "التفضيلات",
    "nl": "",
    "fr": "",
    "de": ""
  },
  "platform.settings.profilesection.privacy_settings": {
    "en": "Privacy Settings",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.profilesection.private_only_visible_to_you": {
    "en": "Private - Only visible to you",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.profilesection.project_updates": {
    "en": "Project Updates",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.profilesection.public_visible_to_everyone": {
    "en": "Public - Visible to everyone",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.profilesection.push_notifications": {
    "en": "Push Notifications",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.profilesection.receive_browser_push_notifications": {
    "en": "Receive browser push notifications",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.profilesection.receive_notifications_via_email": {
    "en": "Receive notifications via email",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.profilesection.receive_product_updates_and_tips": {
    "en": "Receive product updates and tips",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.profilesection.security": {
    "en": "Security",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.profilesection.show_email_address": {
    "en": "Show Email Address",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.profilesection.show_last_login": {
    "en": "Show Last Login",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.profilesection.tell_us_about_yourself": {
    "en": "Tell us about yourself...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.profilesection.two_factor_authentication": {
    "en": "Two-Factor Authentication",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.profilesection.windows": {
    "en": "Windows:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.quicktemplate.default": {
    "en": "Default",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.quicktemplate.enter_value": {
    "en": "Enter value",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.quicktemplate.option_1": {
    "en": "Option 1",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.quicktemplate.option_2": {
    "en": "Option 2",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.settingssectiontemplate.default_option": {
    "en": "Default Option",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.settingssectiontemplate.enter_sample_value": {
    "en": "Enter sample value",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.settingssectiontemplate.option_1": {
    "en": "Option 1",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.settingssectiontemplate.option_2": {
    "en": "Option 2",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.tutorialmanagementsection.active": {
    "en": "Active",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.tutorialmanagementsection.all_roles": {
    "en": "All Roles",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.tutorialmanagementsection.delete_tutorial_task": {
    "en": "Delete Tutorial Task",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.tutorialmanagementsection.description": {
    "en": "Description *",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.tutorialmanagementsection.detailed_instructions_for_completing_this_task": {
    "en": "Detailed instructions for completing this task...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.tutorialmanagementsection.eg_create_your_first_glossary_item": {
    "en": "e.g., Create Your First Glossary Item",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.tutorialmanagementsection.eg_owner_admin_comma_separated": {
    "en": "e.g., Owner, Admin (comma-separated)",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.tutorialmanagementsection.inactive": {
    "en": "Inactive",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.tutorialmanagementsection.role_applicability_leave_empty_for_all_roles": {
    "en": "Role Applicability (leave empty for all roles)",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.tutorialmanagementsection.task_type": {
    "en": "Task Type",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.tutorialmanagementsection.title": {
    "en": "Title *",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.usermanagementsection.loading_users": {
    "en": "Loading users...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.usermanagementsection.no_users_found_invite_users_to_get_started": {
    "en": "No users found. Invite users to get started.",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.usermanagementsection.send_invitation": {
    "en": "Send Invitation",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.settings.usermanagementsection.userexamplecom": {
    "en": "user@example.com",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.subscribe_Parts.step2.company_name": {
    "en": "Company Name",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.subscribe_Parts.step2.company_name_placeholder": {
    "en": "Company Name *",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.subscribe_Parts.step2.first_name": {
    "en": "First Name",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.subscribe_Parts.step2.first_name_placeholder": {
    "en": "First name *",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.subscribe_Parts.step2.job_title": {
    "en": "Job Title",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.subscribe_Parts.step2.job_title_placeholder": {
    "en": "Job Title *",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.subscribe_Parts.step2.last_name": {
    "en": "Last Name",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.subscribe_Parts.step2.last_name_placeholder": {
    "en": "Last name *",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.defaultlanguagetest.default_language_code": {
    "en": "Default Language Code:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.defaultlanguagetest.default_language_name": {
    "en": "Default Language Name:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.defaultlanguagetest.default_language_test": {
    "en": "Default Language Test",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.defaultlanguagetest.game_settings": {
    "en": "Game Settings:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.defaultlanguagetest.selected_game": {
    "en": "Selected Game:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.defaultlanguagetest.source_text_label": {
    "en": "Source Text Label:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.devnodetest.devnode_test": {
    "en": "DevNode Test",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.devnodetest.saved_data": {
    "en": "Saved Data:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.editabletitlecomponenttest.click_on_any_title_to_edit_it": {
    "en": "Click on any title to edit it",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.editabletitlecomponenttest.click_outside_the_input_to_save_changes": {
    "en": "Click outside the input to save changes",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.editabletitlecomponenttest.compact_heading_1": {
    "en": "Compact Heading 1",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.editabletitlecomponenttest.compact_heading_2": {
    "en": "Compact Heading 2",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.editabletitlecomponenttest.compact_heading_3": {
    "en": "Compact Heading 3",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.editabletitlecomponenttest.compact_heading_4": {
    "en": "Compact Heading 4",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.editabletitlecomponenttest.compact_variants": {
    "en": "Compact Variants",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.editabletitlecomponenttest.disabled_state": {
    "en": "Disabled State",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.editabletitlecomponenttest.editabletitlecomponent_test": {
    "en": "EditableTitleComponent Test",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.editabletitlecomponenttest.heading_1_32px": {
    "en": "Heading 1 (32px)",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.editabletitlecomponenttest.heading_2_24px": {
    "en": "Heading 2 (24px)",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.editabletitlecomponenttest.heading_3_20px": {
    "en": "Heading 3 (20px)",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.editabletitlecomponenttest.heading_4_16px": {
    "en": "Heading 4 (16px)",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.editabletitlecomponenttest.heading_5_14px": {
    "en": "Heading 5 (14px)",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.editabletitlecomponenttest.instructions": {
    "en": "Instructions:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.editabletitlecomponenttest.press_enter_to_save_changes": {
    "en": "Press Enter to save changes",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.editabletitlecomponenttest.press_escape_to_cancel_editing": {
    "en": "Press Escape to cancel editing",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.editabletitlecomponenttest.this_title_cannot_be_edited": {
    "en": "This title cannot be edited",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.editabletitlecomponenttest.try_different_header_styles_to_see_the_size_variations": {
    "en": "Try different header styles to see the size variations",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.highlightingtest.available_highlight_items": {
    "en": "Available Highlight Items",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.highlightingtest.available_types": {
    "en": "Available Types:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.highlightingtest.check_the_browser_console_for_highlighting_results": {
    "en": "Check the browser console for highlighting results",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.highlightingtest.current_game_types": {
    "en": "Current Game & Types",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.highlightingtest.enter_text_to_test_highlighting": {
    "en": "Enter text to test highlighting...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.highlightingtest.highlighting_test_multi_word_type_values": {
    "en": "Highlighting Test - Multi-word Type Values",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.highlightingtest.how_to_test": {
    "en": "How to test:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.highlightingtest.make_sure_you_have_types_defined_with_values_eg_a_weight_type_with_values_light_not_so_heavy_heavy": {
    "en": "Make sure you have types defined with values (e.g., a \"weight\" type with values \"light\", \"not so heavy\", \"heavy\")",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.highlightingtest.no_highlight_items_available_make_sure_you_have_types_with_values_defined": {
    "en": "No highlight items available. Make sure you have types with values defined.",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.highlightingtest.note": {
    "en": "Note:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.highlightingtest.selected_game": {
    "en": "Selected Game:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.highlightingtest.test_instructions": {
    "en": "Test Instructions",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.highlightingtest.test_text_input": {
    "en": "Test Text Input",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.highlightingtest.the_system_should_highlight_both_single_words_and_multi_word_phrases_like_not_so_heavy": {
    "en": "The system should highlight both single words and multi-word phrases like \"not so heavy\"",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.highlightingtest.type_text_in_the_input_above_that_includes_those_type_values": {
    "en": "Type text in the input above that includes those type values",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.multiselectdropdowntest.categories": {
    "en": "Categories:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.multiselectdropdowntest.current_selections": {
    "en": "Current Selections:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.multiselectdropdowntest.demonstrating_the_dropdown_component_with_different_data_types": {
    "en": "Demonstrating the dropdown component with different data types",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.multiselectdropdowntest.direct_panel_example": {
    "en": "Direct Panel Example",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.multiselectdropdowntest.filter_by_categories": {
    "en": "Filter by Categories",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.multiselectdropdowntest.filter_by_category": {
    "en": "Filter by Category",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.multiselectdropdowntest.filter_by_tag": {
    "en": "Filter by Tag",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.multiselectdropdowntest.filter_by_tags": {
    "en": "Filter by Tags",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.multiselectdropdowntest.filter_by_tag_title": {
    "en": "Filter by Tag",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.multiselectdropdowntest.filter_by_type": {
    "en": "Filter by Type",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.multiselectdropdowntest.filter_by_types": {
    "en": "Filter by Types",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.multiselectdropdowntest.multiselectdropdown_demo": {
    "en": "MultiSelectDropdown Demo",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.multiselectdropdowntest.search_categories": {
    "en": "Search Categories ...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.multiselectdropdowntest.search_tags": {
    "en": "Search Tags ...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.multiselectdropdowntest.search_tags_placeholder": {
    "en": "Search Tags ...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.multiselectdropdowntest.search_types": {
    "en": "Search Types ...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.multiselectdropdowntest.tags": {
    "en": "Tags:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.multiselectdropdowntest.this_shows_the_panel_directly_without_a_trigger_button_like_in_the_screenshot": {
    "en": "This shows the panel directly without a trigger button (like in the screenshot)",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.multiselectdropdowntest.types": {
    "en": "Types:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.objectdropdowntest.all_items": {
    "en": "All Items:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.objectdropdowntest.character_blueprint": {
    "en": "Character Blueprint",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.objectdropdowntest.glossary_dropdown_test": {
    "en": "Glossary Dropdown Test",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.objectdropdowntest.important_locations": {
    "en": "Important Locations:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.objectdropdowntest.instructions": {
    "en": "Instructions:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.objectdropdowntest.key_items": {
    "en": "Key Items:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.objectdropdowntest.related_characters": {
    "en": "Related Characters:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.objectselectionelementtest.disabled": {
    "en": "Disabled...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.objectselectionelementtest.disabled_state": {
    "en": "Disabled State",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.objectselectionelementtest.glossaryselectionelement_test": {
    "en": "GlossarySelectionElement Test",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.objectselectionelementtest.multiple_selection_with_tag_filtering": {
    "en": "Multiple Selection with Tag Filtering",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.objectselectionelementtest.no_tag_filtering": {
    "en": "No Tag Filtering",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.objectselectionelementtest.select_a_glossary_item": {
    "en": "Select a glossary item...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.objectselectionelementtest.selected_item": {
    "en": "Selected Item:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.objectselectionelementtest.selected_items": {
    "en": "Selected Items:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.objectselectionelementtest.select_glossary_items_no_filtering": {
    "en": "Select glossary items (no filtering)...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.objectselectionelementtest.select_multiple_glossary_items": {
    "en": "Select multiple glossary items...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.objectselectionelementtest.single_selection_with_tag_filtering": {
    "en": "Single Selection with Tag Filtering",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.templatestest.glossary_blueprints_test": {
    "en": "Glossary Blueprints Test",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.templatestest.loading_glossary_blueprints": {
    "en": "Loading glossary blueprints...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.test.templatestest.no_glossary_blueprints_found": {
    "en": "No glossary blueprints found",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.TMS.no_translation": {
    "en": "No Translation",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.companyuserslist.loading_users": {
    "en": "Loading users...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.datasourceorganizer.column_selection": {
    "en": "Column Selection",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.datasourceorganizer.data_source": {
    "en": "Data Source",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.datasourceorganizer.drag_to_reorder": {
    "en": "Drag to reorder",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.datasourceorganizer.select_data_source": {
    "en": "Select data source",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.datasourceorganizer.selected_columns": {
    "en": "Selected columns:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.dropdowns.search_options": {
    "en": "Search options...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.dropdowns.select_company": {
    "en": "Select company",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.dropdowns.select_project": {
    "en": "Select project",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.gameuserselector.error_loading_users": {
    "en": "Error loading users",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.gameuserselector.no_game_selected": {
    "en": "No game selected",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.gameuserselector.search_users": {
    "en": "Search users...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.gameuserslist.error_loading_game_users": {
    "en": "Error loading game users",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.gameuserslist.loading_users": {
    "en": "Loading users...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.gameuserslist.no_game_selected": {
    "en": "No game selected",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.gameuserslist.no_users_found_for_this_game": {
    "en": "No users found for this game.",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.membersdisplay.fetching_user_details": {
    "en": "Fetching user details...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.membersdisplay.no_members_found": {
    "en": "No members found",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.objectselector.search_items": {
    "en": "Search items...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.overflowreportpanel.click_check_all_languages_to_scan_for_overflow_issues": {
    "en": "Click \"Check All Languages\" to scan for overflow issues",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.overflowreportpanel.no_overflow_issues_detected": {
    "en": "No overflow issues detected!",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.overflowreportpanel.overflow_detection": {
    "en": "Overflow Detection",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.rtldebugpanel.current_language": {
    "en": "Current Language:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.rtldebugpanel.direction": {
    "en": "Direction:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.rtldebugpanel.document_dir": {
    "en": "Document Dir:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.rtldebugpanel.document_lang": {
    "en": "Document Lang:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.rtldebugpanel.game_default": {
    "en": "Game Default:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.rtldebugpanel.game_languages": {
    "en": "Game Languages:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.rtldebugpanel.is_rtl": {
    "en": "Is RTL:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.rtldebugpanel.localstorage": {
    "en": "LocalStorage:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.rtldebugpanel.mixed_content_test": {
    "en": "Mixed Content Test:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.rtldebugpanel.test_text_current": {
    "en": "Test Text (Current):",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.tagmanager.custom_tags": {
    "en": "Custom tags",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.tagmanager.from_blueprint_cannot_be_removed": {
    "en": "From blueprint (cannot be removed)",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.tagmanager.type_tag_name_and_press_enter": {
    "en": "Type tag name and press Enter...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.tagselector.available_tags": {
    "en": "Available Tags",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.tagselector.color": {
    "en": "Color:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.tagselector.group_optional": {
    "en": "Group (optional)",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.tagselector.tag_name": {
    "en": "Tag name",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.togglecheckbuttonexample.toggle_check_button_example": {
    "en": "Toggle Check Button Example",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.unityexportdialog.all_referenced_images_in_an_images_folder": {
    "en": "All referenced images in an Images folder",
    "ar": "جميع الصور المشار إليها في مجلد الصور",
    "nl": "",
    "fr": "",
    "de": ""
  },
  "platform.ui.unityexportdialog.export_filename": {
    "en": "Export Filename",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.unityexportdialog.images": {
    "en": "Images/",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.unityexportdialog.locakeys_preserved_as_placeholders_for_runtime_localization": {
    "en": "LocaKeys preserved as placeholders for runtime localization",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.unityexportdialog.readmetxt": {
    "en": "README.txt",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.unityexportdialog.readme_with_integration_instructions_and_c_example_code": {
    "en": "README with integration instructions and C# example code",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.unityexportdialog.uiuss": {
    "en": "UI.uss",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.unityexportdialog.uiuxml": {
    "en": "UI.uxml",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.unityexportdialog.unity_ui_export": {
    "en": "unity-ui-export",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.unityexportdialog.uss_file_with_styles_unitys_css_equivalent": {
    "en": "USS file with styles (Unity's CSS equivalent)",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.unityexportdialog.uxml_file_with_ui_structure_unitys_html_equivalent": {
    "en": "UXML file with UI structure (Unity's HTML equivalent)",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.unityexportdialog.what_youll_get": {
    "en": "What you'll get:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.ui.userselector.search_users": {
    "en": "Search users...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.blueprints.000000": {
    "en": "#000000",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.blueprints.add_documentation_for_this_field": {
    "en": "Add documentation for this field...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.blueprints.add_documentation_for_this_section": {
    "en": "Add documentation for this section...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.blueprints.card_color": {
    "en": "Card Color",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.blueprints.c_code": {
    "en": "C++ Code",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.blueprints.color": {
    "en": "Color:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.blueprints.create_a_glossary_blueprint_first_to_add_glossary_items": {
    "en": "Create a glossary blueprint first to add glossary items",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.blueprints.developer_notes": {
    "en": "Developer Notes",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.blueprints.documentation_view": {
    "en": "Documentation View",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.blueprints.enter_document_name": {
    "en": "Enter document name...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.blueprints.enter_glossary_item_name": {
    "en": "Enter glossary item name...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.blueprints.enter_subtitle": {
    "en": "Enter subtitle...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.blueprints.enter_template_description": {
    "en": "Enter template description...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.blueprints.enter_type": {
    "en": "Enter type...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.blueprints.f3f5a3": {
    "en": "#f3f5a3",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.blueprints.field_label": {
    "en": "Field label",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.blueprints.godot_code": {
    "en": "Godot Code",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.blueprints.json_structure": {
    "en": "JSON Structure",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.blueprints.loading_blueprints": {
    "en": "Loading blueprints...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.blueprints.no_glossary_blueprints_available": {
    "en": "No glossary blueprints available",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.blueprints.normal_view": {
    "en": "Normal View",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.blueprints.remove_filter_options_first": {
    "en": "Remove filter options first",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.blueprints.roblox_code": {
    "en": "Roblox Code",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.blueprints.section_title": {
    "en": "Section Title",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.blueprints.select_or_add_tags_for_this_document": {
    "en": "Select or add tags for this document...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.blueprints.select_or_add_tags_for_this_item": {
    "en": "Select or add tags for this item...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.blueprints.select_tags": {
    "en": "Select tags...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.blueprints.tags": {
    "en": "Tags",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.blueprints.typescript_code": {
    "en": "TypeScript Code",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.blueprints.unity_code": {
    "en": "Unity Code",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.blueprints.unsaved_template_changes": {
    "en": "Unsaved Template Changes",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.blueprints.view_mode": {
    "en": "View mode",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.dataview.basic_info": {
    "en": "Basic Info",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.dataview.interval": {
    "en": "Interval:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.dataview.name": {
    "en": "Name:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.dataview.saving": {
    "en": "Saving:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.dataview.tags": {
    "en": "Tags:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.dataviewtest.dataview_test_component": {
    "en": "DataView Test Component",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.dataviewtest.test_data": {
    "en": "Test Data",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.dataview.title": {
    "en": "Title:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.dataview.type": {
    "en": "Type:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.dataview.types": {
    "en": "Types:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.dataview.version": {
    "en": "Version:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.dialog.conversation_text": {
    "en": "Conversation Text *",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.dialog.default_next_section": {
    "en": "Default Next Section",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.dialog.dialog_key": {
    "en": "Dialog Key *",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.dialog.dialog_name": {
    "en": "Dialog Name *",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.dialog.eg_greeting_choice1": {
    "en": "e.g., greeting, choice_1",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.dialog.eg_introconversation": {
    "en": "e.g., intro_conversation",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.dialog.enter_dialog_description": {
    "en": "Enter dialog description",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.dialog.enter_dialog_name": {
    "en": "Enter dialog name",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.dialog.enter_option_text": {
    "en": "Enter option text",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.dialog.enter_the_conversation_text_for_this_section": {
    "en": "Enter the conversation text for this section",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.dialog.next_section": {
    "en": "Next Section",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.dialog.none_end_dialog": {
    "en": "None (End dialog)",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.dialog.none_use_section_default": {
    "en": "None (Use section default)",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.dialog.options_answer_choices": {
    "en": "Options (Answer Choices)",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.dialog.section_identifier": {
    "en": "Section Identifier *",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.dialog.sections": {
    "en": "Sections",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.dialog.translatable": {
    "en": "Translatable",
    "nl": "Vertaalbaar",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.dialog.translatable_add_to_tms": {
    "en": "Translatable (Add to TMS)",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.documentation_view": {
    "en": "Documentation View",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.glossary.add_an_identifier": {
    "en": "Add an identifier...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.glossary.add_a_tag": {
    "en": "Add a tag...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.glossary.all_objects_will_be_created_as_drafts": {
    "en": "All objects will be created as drafts",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.glossary.c_code": {
    "en": "C++ Code",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.glossary.click_to_open_template_in_new_tab": {
    "en": "Click to open template in new tab",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.glossary.create_a_glossary_template_first_to_use_bulk_creation": {
    "en": "Create a glossary template first to use bulk creation",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.glossary.documentation_view": {
    "en": "Documentation View",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.glossary.enter_object_names_one_per_line10example10characterhero10charactervillain10charactersidekick": {
    "en": "Enter object names, one per line&#10;Example:&#10;Character_Hero&#10;Character_Villain&#10;Character_Sidekick",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.glossary.enter_template_name": {
    "en": "Enter template name",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.glossary.fields_that_no_longer_exist_in_the_template": {
    "en": "Fields that no longer exist in the template:",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.glossary.godot_code": {
    "en": "Godot Code",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.glossary.identifiers_help_text": {
    "en": "Identifiers names that will be used to link this glossary item to several elements in your game.",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.glossary.json_structure": {
    "en": "JSON Structure",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.glossary.loading_form_sections": {
    "en": "Loading form sections...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.glossary.loading_glossary_blueprint": {
    "en": "Loading glossary blueprint...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.glossary.modified": {
    "en": "Modified",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.glossary.no_glossary_templates_available": {
    "en": "No glossary templates available",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.glossary.normal_view": {
    "en": "Normal View",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.glossary.not_set": {
    "en": "Not set",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.glossary.objects_will_have_the_template_structure_with_empty_fields_allowing_you_to_fill_them_in_later": {
    "en": "Objects will have the template structure with empty fields, allowing you to fill them in later.",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.glossary.OutOfSync": {
    "en": "This object uses an older template version. The template has been updated since this object was created",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.glossary.preparing_form": {
    "en": "Preparing form...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.glossary.remove_identifier": {
    "en": "Remove identifier",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.glossary.remove_this_field": {
    "en": "Remove this field",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.glossary.roblox_code": {
    "en": "Roblox Code",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.glossary.tags": {
    "en": "Tags",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.glossary.this_object_uses_an_older_template_version_the_template_has_been_updated_since_this_object_was_created": {
    "en": "This object uses an older template version. The template has been updated since this object was created.",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.glossary.typescript_code": {
    "en": "TypeScript Code",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.glossary.unity_code": {
    "en": "Unity Code",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.glossary.unsaved_object_changes": {
    "en": "Unsaved Object Changes",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.glossary.view_mode": {
    "en": "View mode",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.glossary.what_would_you_like_to_do_with_the_selected_fields": {
    "en": "What would you like to do with the selected fields?",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.godot_code": {
    "en": "Godot Code",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.json_structure": {
    "en": "Json Structure",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.normal_view": {
    "en": "Normal View",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.preparing_form": {
    "en": "Preparing Form",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.roblox_code": {
    "en": "Roblox Code",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.shared.not_set": {
    "en": "Not set",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.typescript_code": {
    "en": "Typescript Code",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.unity_code": {
    "en": "Unity Code",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.unsaved_data": {
    "en": "You have unsaved changes",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.view_mode": {
    "en": "View Mode",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.wizard-elements.enter_link_text_optional": {
    "en": "Enter link text (optional)",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  },
  "platform.wizards.wizard-elements.enter_url": {
    "en": "Enter URL...",
    "nl": "",
    "fr": "",
    "de": "",
    "ar": ""
  }
} as const;

export type TranslationKey = keyof typeof platformTranslations;
export type LanguageCode = "ar" | "de" | "en" | "fr" | "nl";

// Get all available languages
export const availableLanguages: LanguageCode[] = ["ar", "de", "en", "fr", "nl"];

// Helper function to get translation
export function getPlatformTranslation(
  key: TranslationKey,
  language: LanguageCode,
  fallback?: string
): string {
  const translations = platformTranslations[key];
  if (!translations) return fallback || key;
  return translations[language] || translations['en'] || fallback || key;
}
